// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aC5O","icon":"styles_icon__3Depo"};